import { futureBooking } from "./futureBooking";

const BOOKING_STATUS = {
    UPCOMING : "upcoming",
    PREVIOUS : "previous"
}

export const viewBooking = () => {
    const root = document.querySelector("[js-view-booking]");

    if (root) {
        const type = root.getAttribute(
            "js-view-booking-type")?.toLowerCase();

        if (type == BOOKING_STATUS.UPCOMING) {
            futureBooking(root);
        } else if (type == BOOKING_STATUS.PREVIOUS) {
            pastBooking();
        }
    }
}

const pastBooking = () => {
    // scripting for previous bookings page goes here, if needed
}